<template>
  <div>
    <div>
      <a-button type="default" @click="$router.back()"><a-icon type="rollback" /> Quay lại</a-button>
    </div>
    <br/>
    <a-card title="Chỉnh sửa công việc" class="root-card">
      <a-form-model layout="vertical" v-bind="{labelCol: { span: 3 },wrapperCol: { span: 18 },}">
        <a-form-model-item label="Tiêu đề">
          <a-input placeholder="Tiêu đề" v-model="formData.editJob.title" />
        </a-form-model-item>
        <a-form-model-item label="Mô tả">
          <a-textarea placeholder="Mô tả" v-model="formData.editJob.description" :auto-size="{ minRows: 4, maxRows: 8 }"></a-textarea>
        </a-form-model-item>
        <a-form-model-item label="Số lần lặp của nhiệm vụ">
          <a-input type="number" v-model="formData.editJob.loop" >
            <a-tooltip slot="suffix">
              <template slot="title">
                Số lần lặp của nhiệm vụ, khi hết số lần lặp sẽ kết thúc nhiệm vụ. Nết đặt bằng -1 sẽ lặp vĩnh viễn
              </template>
              <a-icon type="question-circle" style="color: rgba(0,0,0,.45)" />
            </a-tooltip>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="Delay giao nhiệm vụ">
          <a-input placeholder="Milisecond" type="number" v-model="formData.editJob.delay_assign_task" >
            <a-tooltip slot="suffix">
              <template slot="title">
                Khi bạn thực thi một công việc, nếu bạn đặt giá trị này, thì khi giao nhiệm vụ sẽ chờ thời gian này, rồi mới giao nhiệm vụ cho worker tiếp theo.
                Ví dụ, giao nhiệm vụ 1 cho worker A, thì chờ n mili giây mới giao nhiệm vụ 2 cho worker B. Nếu không cài đặt thì giao tất cả nhiệm vụ khả thi
                cho tất cả các worker rảnh rỗi ngay lập tức.
              </template>
              <a-icon type="question-circle" style="color: rgba(0,0,0,.45)" />
            </a-tooltip>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="Quy trình - trước tất cả">
          <a-card hoverable>
            <template slot="actions">
              <a-icon key="setting" @click="chooseProcedure('procedure_before')" type="setting" />
              <a-icon key="close" v-if="!!getProcedure(formData.editJob.procedure_before)" type="close" @click="formData.editJob.procedure_before = undefined" />
              <a-icon key="edit" v-if="!!getProcedure(formData.editJob.procedure_before)" @click="openEditProcedure(formData.editJob.procedure_before)" type="edit" />
            </template>
            <a-card-meta v-if="!!getProcedure(formData.editJob.procedure_before)" :title="getProcedure(formData.editJob.procedure_before)?.title" :description="getProcedure(formData.editJob.procedure_before)?.description">
            </a-card-meta>
          </a-card>
        </a-form-model-item>
        <a-form-model-item label="Quy trình - trước mỗi bước">
          <a-card hoverable>
            <template slot="actions">
              <a-icon key="setting" @click="chooseProcedure('procedure_before_each')" type="setting" />
              <a-icon key="close" v-if="!!getProcedure(formData.editJob.procedure_before_each)" type="close" @click="formData.editJob.procedure_before_each = undefined" />
              <a-icon key="edit" v-if="!!getProcedure(formData.editJob.procedure_before_each)" @click="openEditProcedure(formData.editJob.procedure_before_each)" type="edit" />
            </template>
            <a-card-meta v-if="!!getProcedure(formData.editJob.procedure_before_each)" :title="getProcedure(formData.editJob.procedure_before_each)?.title" :description="getProcedure(formData.editJob.procedure_before_each)?.description">
            </a-card-meta>
          </a-card>
        </a-form-model-item>
        <a-form-model-item label="Quy trình - chính">
          <a-card hoverable>
            <template slot="actions">
              <a-icon key="setting" @click="chooseProcedure('procedure_id')" type="setting" />
              <a-icon key="close" v-if="!!getProcedure(formData.editJob.procedure_id)" type="close" @click="formData.editJob.procedure_id = undefined" />
              <a-icon key="edit" v-if="!!getProcedure(formData.editJob.procedure_id)" @click="openEditProcedure(formData.editJob.procedure_id)" type="edit" />
            </template>
            <a-card-meta v-if="!!getProcedure(formData.editJob.procedure_id)" :title="getProcedure(formData.editJob.procedure_id)?.title" :description="getProcedure(formData.editJob.procedure_id)?.description">
            </a-card-meta>
          </a-card>
        </a-form-model-item>
        <a-form-model-item label="Quy trình - sau khi hoàn thành mỗi bước">
          <a-card hoverable>
            <template slot="actions">
              <a-icon key="setting" @click="chooseProcedure('procedure_after_each')" type="setting" />
              <a-icon key="close" v-if="!!getProcedure(formData.editJob.procedure_after_each)" type="close" @click="formData.editJob.procedure_after_each = undefined" />
              <a-icon key="edit" v-if="!!getProcedure(formData.editJob.procedure_after_each)" @click="openEditProcedure(formData.editJob.procedure_after_each)" type="edit" />
            </template>
            <a-card-meta v-if="!!getProcedure(formData.editJob.procedure_after_each)" :title="getProcedure(formData.editJob.procedure_after_each)?.title" :description="getProcedure(formData.editJob.procedure_after_each)?.description">
            </a-card-meta>
          </a-card>
        </a-form-model-item>
        <a-form-model-item label="Quy trình - sau khi hoàn thành">
          <a-card hoverable>
            <template slot="actions">
              <a-icon key="setting" @click="chooseProcedure('procedure_after')" type="setting" />
              <a-icon key="close" v-if="!!getProcedure(formData.editJob.procedure_after)" type="close" @click="formData.editJob.procedure_after = undefined" />
              <a-icon key="edit" v-if="!!getProcedure(formData.editJob.procedure_after)" @click="openEditProcedure(formData.editJob.procedure_after)" type="edit" />
            </template>
            <a-card-meta v-if="!!getProcedure(formData.editJob.procedure_after)" :title="getProcedure(formData.editJob.procedure_after)?.title" :description="getProcedure(formData.editJob.procedure_after)?.description">
            </a-card-meta>
          </a-card>
        </a-form-model-item>
        <a-form-model-item label="Quy trình - khi bị lỗi">
          <a-card hoverable>
            <template slot="actions">
              <a-icon key="setting" @click="chooseProcedure('procedure_error')" type="setting" />
              <a-icon key="close" v-if="!!getProcedure(formData.editJob.procedure_error)" type="close" @click="formData.editJob.procedure_error = undefined" />
              <a-icon key="edit" v-if="!!getProcedure(formData.editJob.procedure_error)" @click="openEditProcedure(formData.editJob.procedure_error)" type="edit" />
            </template>
            <a-card-meta v-if="!!getProcedure(formData.editJob.procedure_error)" :title="getProcedure(formData.editJob.procedure_error)?.title" :description="getProcedure(formData.editJob.procedure_error)?.description">
            </a-card-meta>
          </a-card>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" :loading="loading.editJob" @click="handleEditJob"><a-icon type="save" /> Lưu lại</a-button>
        </a-form-model-item>
      </a-form-model>
      <a-modal id="procedures-modal" width="1000px" v-model="visible.chooseProcedureModal" title="Danh sách quy trình" @ok="() => visible.chooseProcedureModal = false">
        <div v-if="!procedures || procedures?.length == 0">Không có quy trình nào!</div>
        <a-list :grid="{ gutter: 16, column: 3 }" :data-source="procedures">
          <a-list-item slot="renderItem" slot-scope="procedure">
            <a-card hoverable>
              <template slot="actions">
                <a-icon key="add" type="check" @click="() => {
                  formData.editJob[chooseProcedureKey] = procedure.id;
                  visible.chooseProcedureModal = false;
                }"/>
                <a-icon key="edit" @click="openEditProcedure(procedure.id)" type="edit" />
              </template>
              <a-card-meta style="height: 115px; white-space: pre-wrap;text-overflow: ellipsis;overflow: hidden;" :title="procedure.title" :description="procedure.description">
              </a-card-meta>
            </a-card>
          </a-list-item>
        </a-list>
      </a-modal>
    </a-card>
  </div>
</template>
<style scoped>
#procedures-modal .card-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 16px;
}

#procedures-modal .card {
  margin-bottom: 16px;
}

.ant-form-item {
  margin-bottom: 10px !important;
}
</style>
<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: {
        editJob: false
      },
      visible: {
        chooseProcedureModal: false,
        editJob: false
      },
      formData: {
        editJob: {
          title: undefined,
          description: undefined,
          loop: 1,
          procedure_id: undefined,
          delay_assign_task: undefined,
          procedure_before: undefined,
          procedure_before_each: undefined,
          procedure_after_each: undefined,
          procedure_after: undefined,
          procedure_error: undefined
        }
      },
      chooseProcedureKey: undefined
    }
  },
  async mounted() {
    await this.fetchProcedures();
    this.handleFetchJob();
  },
  computed: {
    ...mapGetters('procedure', {
      procedures: "getProcedures"
    }),

    ...mapGetters('job', {
      jobs: "getJobs"
    }),

    job() {
      return this.jobs[0];
    },

    choosedProcedure() {
      const procedure_id = this.formData.editJob.procedure_id;

      if (!procedure_id) {
        return undefined;
      }

      return this.procedures.find(procedure => procedure.id == procedure_id);
    }
  },
  methods: {
    ...mapActions('procedure', {
      fetchProcedures: "fetchProcedures"
    }),

    ...mapActions('job', {
      updateJob: "updateJob",
      fetchJobById: "fetchJobById"
    }),

    getProcedure(procedure_id) {
      if (!procedure_id) {
        return undefined;
      }

      return this.procedures.find(procedure => procedure.id == procedure_id);
    },

    chooseProcedure(procedureKey) {
      this.chooseProcedureKey = procedureKey;
      this.visible.chooseProcedureModal = true;
    },

    async handleFetchJob() {
      await this.fetchJobById(this.id);
      this.formData.editJob.title = this.job?.title;
      this.formData.editJob.loop = this.job?.loop;
      this.formData.editJob.description = this.job?.description;
      this.formData.editJob.procedure_id = this.job?.procedure;
      this.formData.editJob.delay_assign_task = this.job?.delay_assign_task;
      this.formData.editJob.procedure_before = this.job?.subprocedures?.before;
      this.formData.editJob.procedure_before_each = this.job?.subprocedures?.before_each;
      this.formData.editJob.procedure_after_each = this.job?.subprocedures?.after_each;
      this.formData.editJob.procedure_after = this.job?.subprocedures?.after;
      this.formData.editJob.procedure_error = this.job?.subprocedures?.error;
    },

    openEditProcedure(id) {
      const href = this.$router.resolve({
        name: 'EditProcedure',
        params: { id: (typeof id == 'string') ? id : this.formData.editJob.procedure_id }
      }).href;

      global.open(href);
    },

    async handleEditJob() {
      this.loading.editJob = true;

      try {
        const {message} = await this.updateJob({
          id: this.id,
          params: this.formData.editJob
        });
        this.$message.success(message);
        this.$router.push({name: 'ListJob'});
      }
      catch(error) {
        this.$message.error(error?.response?.data?.error?.message || error?.response?.data || error?.message);
      }

      this.loading.editJob = false;
    }
  }
};
</script>
